import { IntegrationServiceId } from '../../../../../common/integrations'
import { ClickNavigationProps } from '../../../../../components/NavigationWithSideBar/ClickNavigation'

import { CRMIntegrationTaskSettings } from '../CRMIntegrationTaskSettings'
import { HubSpotContactSyncSettings } from './HubSpotContactSyncSettings'

export const HubSpotSpecificSettings = (): ClickNavigationProps[] => {
  return [
    { id: 'contactSync', label: 'Contact Sync', content: () => <HubSpotContactSyncSettings /> },
    { id: 'task', label: 'Task', content: () => <CRMIntegrationTaskSettings serviceId={IntegrationServiceId.HUBSPOT} /> },
  ]
}
